import Vue from "vue";
import router from "@/router";
import store from "@/store";
import { getToken } from "@/utils/cookies";
import { sessionIdleTimeout } from "@/config/env";

// 会话闲置超时自动锁定：
// 用户在配置的时长内无任何操作时，清除登录凭证并跳转登录页要求重新认证。
// 超时时长由部署配置 window.g.sessionIdleTimeout（分钟）下发，<=0 或未配置时不启用。

const ACTIVITY_KEY = "csim-last-activity"; // 最近活动时间戳（localStorage，跨标签页共享）
const WRITE_THROTTLE = 1000; // 活动时间戳写入节流（毫秒）
const CHECK_INTERVAL = 10000; // 闲置检查间隔（毫秒）

// 视为"有操作"的用户行为
const ACTIVITY_EVENTS = ["mousedown", "mousemove", "keydown", "wheel", "touchstart", "scroll"];

let initialized = false;
let locking = false; // 防止重复触发锁定
let lastWrite = 0;

function onActivity() {
	const now = Date.now();
	if (now - lastWrite >= WRITE_THROTTLE) {
		lastWrite = now;
		try {
			localStorage.setItem(ACTIVITY_KEY, String(now));
		} catch (e) {
			// localStorage 不可用时忽略，仅本标签页内存计时
		}
	}
}

function getLastActivity() {
	try {
		const value = Number(localStorage.getItem(ACTIVITY_KEY));
		return value > 0 ? value : Date.now();
	} catch (e) {
		return Date.now();
	}
}

// 锁定会话：清凭证、断开WebSocket、跳转登录页
function lockSession() {
	locking = true;
	try {
		if (Vue.prototype.$socket) {
			Vue.prototype.$disconnect();
		}
	} catch (e) {
		// 连接可能已关闭，忽略
	}
	store.dispatch("logout");
	const navigation = router.replace({ path: "/login", query: { reason: "idle" } });
	const unlock = () => {
		locking = false;
	};
	if (navigation && typeof navigation.then === "function") {
		navigation.then(unlock, unlock);
	} else {
		unlock();
	}
}

function checkIdle() {
	if (locking) return;
	if (!getToken()) return; // 未登录时不处理
	if (router.currentRoute.path === "/login") return;
	if (Date.now() - getLastActivity() >= sessionIdleTimeout * 60 * 1000) {
		lockSession();
	}
}

// 初始化闲置监听，在 main.js 中应用启动后调用一次
export function initSessionIdleLock() {
	if (initialized || sessionIdleTimeout <= 0) return;
	initialized = true;

	ACTIVITY_EVENTS.forEach((event) => {
		window.addEventListener(event, onActivity, { passive: true });
	});

	// 从后台切回时立即检查一次，避免等到下一个周期
	document.addEventListener("visibilitychange", () => {
		if (!document.hidden) checkIdle();
	});

	setInterval(checkIdle, CHECK_INTERVAL);
}
